import { ApolloError } from '@apollo/client/errors';

const DEFAULT_ERROR = 'ERROR.DEFAULT';

// export type Message = {
//   description: string,
//   args: any
// }

export class CustomError {
  public code: string;
  public message: string;
  public messages: { code: string; description: string }[];

  constructor() {}

  public static newInstance(code: string, message: string): CustomError {
    const customError = new CustomError();
    customError.code = code;
    customError.message = message;
    return customError;
  }

  public static convert(error: any): CustomError {
    const customError = new CustomError();
    if (error instanceof ApolloError) {
      const apolloError: ApolloError = error;
      if (apolloError.graphQLErrors && apolloError.graphQLErrors.length === 1) {
        console.warn('A');
        console.warn(apolloError.graphQLErrors);
        const graphqlError = apolloError.graphQLErrors[0];
        customError.message = graphqlError.message;
        customError.code = graphqlError.extensions?.['code'] as string;

        if (graphqlError.extensions && graphqlError.extensions['messages']) {
          const messages = graphqlError?.extensions['messages'] as { code: string; description: string }[];
          if (messages && messages.length > 0) {
            customError.messages = messages;
          }
        }
      } else if (apolloError.graphQLErrors.length > 1) {
        console.warn('B');
        customError.messages = apolloError.graphQLErrors.map((graphqlError) => {
          return {
            code: graphqlError.extensions?.['code'] as string,
            description: graphqlError.message,
          };
        });
      } else if (apolloError.networkError) {
        console.warn('C');
        customError.message = apolloError.networkError.message;
        customError.code = (apolloError.networkError as any).code;
      } else {
        customError.message = DEFAULT_ERROR;
      }
    } else if (error instanceof CustomError) {
      return error;
    } else if (error) {
      customError.message = DEFAULT_ERROR;
    }
    return customError;
  }
}
